import { inject, Injectable, signal } from '@angular/core';
import { Database, get, ref } from '@angular/fire/database';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ContextService {
  private database = inject(Database);
  private client = signal<any>(null);
  previousUrl: string | null = null;
  currentUrl: string | null = null;

  constructor(private router: Router) {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = e.urlAfterRedirects;
      });
  }


  getClientValue(): any {
    return this.client();
  }

  async getClient(routeName: string): Promise<any> {
    const clientRef = `adminApp/clients/${routeName}/info/public`;
    const clientId = (
      await get(ref(this.database, clientRef))
    ).val();
    this.client.set(clientId);
    return clientId;
  }
}
